<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <div class="level-left">
          <img src="../assets/truckl-logo.png" width="100" title="Truckl" />
        </div>

        <div class="level-item">
          Truckl Registration
        </div>

      </div>

      <progress-tracker class="progress-tracker" :steps="flowOrderDisplayNames" :current="currentPosition" />

      <form @submit.prevent >
        <keep-alive>
          <router-view ref="step" @canBeSubmitted="setCanGoToNext" class="container"/>
        </keep-alive>

        <div class="columns">
          <div class="column is-one-fifth">
            <a href="/"
               @click.prevent="cancelRegistration"
               tabindex="-1"
               class="button is-medium is-fullwidth"
               :disabled="isSaving"
               v-show="!hasPrevious">
              Cancel
            </a>

            <router-link class="button is-medium is-fullwidth"
                         :disabled="isSaving"
                         v-show="hasPrevious"
                         :to="{ 'name': previousRoute? previousRoute.routeName : '' }">
              Back
            </router-link>
          </div>

          <div class="column is-two-fifths">
            <button type="submit"
                    @click="saveStepData"
                    class="button is-medium is-fullwidth is-primary"
                    :class="{ 'is-loading': isSaving }"
                    title=""
                    :disabled="!canGoToNext">
              <span v-show="hasNext">Next</span>
              <span v-show="!hasNext">Finish</span>
            </button>
          </div>
        </div>

      </form>



    </div>
  </div>
</template>

<script>
import ProgressTracker from '@/components/ProgressTrackerBar'
export default {
  name: 'RegistrationPage',

  components: {
    ProgressTracker
  },

  data() {
    return {
      isSaving: false,
      canGoToNext: false,
      canGoBackToAccount: true,
      flowOrder: []
    }
  },

  computed: {
    /**
     * Current position in registration flow
     * @returns {number} Index of current position
     */
    currentPosition() {
      const matchedSubRoute = this.$route.matched[1]
      return this.flowOrder.findIndex((flowItem) => flowItem.routeName === matchedSubRoute.name)
    },

    /**
     * Convenience property to feed the progress tracker.
     * @returns {Array<String>} List of display names for registration routes
     */
    flowOrderDisplayNames() {
      return this.flowOrder.map((flowItem) => flowItem.displayName)
    },

    /**
     * Percent representing registration progress
     * @returns {number} Progress percent
     */
    registrationProgress() {
      return ((this.currentPosition + 1) / this.flowOrder.length) * 100
    },

    /**
     * Name of the next registration sub-route
     * @returns {string} Route name
     */
    nextRoute() {
      return this.flowOrder[this.currentPosition + 1]
    },

    /**
     * Name of the previous registration sub-route
     * @returns {string} Route name
     */
    previousRoute() {
      return this.flowOrder[this.currentPosition - 1]
    },

    /**
     * Is there a next step?
     * @returns {boolean} True if yes, otherwise false
     */
    hasNext() {
      return !!this.nextRoute
    },

    /**
     * Is there a previous step?
     * @returns {boolean} True if yes, otherwise false
     */
    hasPrevious() {
      // XXX: this is sort of a hack - if the user goes directly to step 2 of registration... then don't let them go back
      if (this.currentPosition === 1 && !this.canGoBackToAccount) {
        return false
      }
      return !!this.previousRoute
    }
  },

  created() {
    this._computeFlowOrder()
  },

  mounted() {
    // XXX: this is sort of a hack - if the user goes directly to step 2 of registration... then don't let them go back
    if (this.currentPosition === 1) {
      this.canGoBackToAccount = false
    }
    /*
    if (this.$route.params.hasOwnProperty('canGoBack')) {
      this.canGoBack = this.$route.params.canGoBack
    }
    */
  },

  methods: {
    setCanGoToNext(value) {
      this.canGoToNext = value
    },
    /**
     * Call the `register()` method on the current component.
     * Intended to be called before moving from one step to another.
     *
     * @returns {Promise<void>} Empty promise
     */
    async saveStepData() {
      this.isSaving = true
      try {
        await this.$refs['step'].register()
        if (this.canGoToNext) {
          this.goToNextStep()
        }
      } catch (error) {
        // TODO: handle error
        console.error('Error during registration: ', error)
      } finally {
        this.isSaving = false
      }
    },

    /**
     * Move registration along
     */
    goToNextStep() {
      this.canGoToNext = false
      console.log('trying to go to next step')
      if (this.hasNext) {
        this.$router.push({ name: this.nextRoute.routeName })
      } else {
        this.$router.push({ name: 'dashboard' })
      }
    },

    /**
     * Performs initial computation for determining the registration flow order based on the order of the sub-routes
     * @private
     */
    _computeFlowOrder() {
      // the top-most element in the `matched` array is always the parent route
      const parentRoute = this.$route.matched[0]
      // based on the parent route path, get its definition.
      const routeDefinition = this.$router.options.routes.find((route) => route.path === parentRoute.path)
      // grab the order of its child/sub-routes. that is what will determine the order of screens of registration
      this.flowOrder = routeDefinition.children.map((childRoute) => ({
        routeName: childRoute.name,
        displayName: childRoute.meta.displayName
      }))
    },

    cancelRegistration() {
      window.sessionStorage.clear()
      window.localStorage.clear()
      window.location = '/'
    }
  }
}
</script>

<style scoped lang="scss">
.section::after {
  content: '';
  background-image: url('../assets/backgrounds/image002.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.4;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  z-index: -1;
}

.container {
  margin-bottom: 20px;
}

.progress-tracker {
  margin-bottom: 50px;
}
</style>
